import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getVueI18n } from '@/i18n/lib/i18n'

Vue.use(VueI18n)

export const i18n = getVueI18n()

Object.defineProperty(Vue.prototype, '$locale', {
  get: function () {
    return i18n.locale
  },
  set: function (locale) {
    i18n.locale = locale
  },
})
